const reviews = [
  {
    id: 1,
    name: "susan smith",
    job: "Scientist",
    image:
      "https://res.cloudinary.com/chuksmbanaso/image/upload/v1645199034/media/lover5_bmwwxq.jpg",
    text: "I'm baby meggings twee health goth +1. Bicycle rights tumeric chartreuse before they sold out chambray pop-up. Shaman humblebrag pickled coloring book salvia hoodie, cold-pressed four dollar toast everyday carry",
  },
  {
    id: 2,
    name: "anna johnson",
    job: "Business Analyst",
    image:
      "https://res.cloudinary.com/chuksmbanaso/image/upload/v1645198994/media/lover3_i5hvth.jpg",
    text: "Helvetica artisan kinfolk thundercats lumbersexual blue bottle. Disrupt glossier gastropub deep v vice franzen hell of brooklyn twee enamel pin fashion axe.photo booth jean shorts artisan narwhal.",
  },
  {
    id: 3,
    name: "peter jones",
    job: "Doctor",
    image:
      "https://res.cloudinary.com/chuksmbanaso/image/upload/v1645198980/media/lover2_x2yend.jpg",
    text: "Sriracha literally flexitarian irony, vape marfa unicorn. Glossier tattooed 8-bit, fixie waistcoat offal activated charcoal slow-carb marfa hell of pabst raclette post-ironic jianbing swag.",
  },
  {
    id: 4,
    name: "bill anderson",
    job: "Chemist",
    image:
      "https://res.cloudinary.com/chuksmbanaso/image/upload/v1645198979/media/lover1_a6jrs8.jpg",
    text: "Edison bulb put a bird on it humblebrag, marfa pok pok heirloom fashion axe cray stumptown venmo actually seitan. VHS farm-to-table schlitz, edison bulb pop-up 3 wolf moon tote bag street art shabby chic. ",
  },
];

export default reviews;
